<template>
    <div>
        <!-- Header -->
        <!-- Header -->
        <!-- Header -->
        <navbar :logo="logo" :auth-user="authUser" class="position-absolute top-0 start-0 w-100" style="z-index: 1000;"></navbar>

        <!-- Page Hero -->
        <section class="page-hero d-flex align-items-center justify-content-center text-center text-white position-relative"
            style="background-color: #333; height: 400px; overflow: hidden;">
            <img src="https://placehold.co/1920x400/333333/666666?text=Products+Hero"
                class="position-absolute w-100 h-100 object-fit-cover opacity-50" alt="Hero">
            <div class="position-relative z-1 mt-5">
                <h1 class="display-4 fw-bold font-serif mb-2">Products</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a href="/"
                                class="text-white text-decoration-none small">Home</a></li>
                        <li class="breadcrumb-item active text-white-50 small" aria-current="page">Products</li>
                    </ol>
                </nav>
            </div>
        </section>

        <!-- Torn Paper Effect Bottom -->
        <div class="position-relative">
            <div class="torn-paper-edge"></div>
        </div>

        <!-- Main Content -->
        <section class="py-5 bg-light-creme">
            <div class="container">
                <div class="row">
                    <!-- Sidebar -->
                    <div class="col-lg-3 pe-lg-5">

                        <!-- Filter Header -->
                        <div
                            class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2 border-secondary-subtle">
                            <h5 class="fw-bold mb-0"><i class="bi bi-sliders me-2"></i>Filter</h5>
                            <a href="#" class="text-muted small text-decoration-none" @click.prevent="resetFilters"><i
                                    class="bi bi-arrow-clockwise me-1"></i> Reset</a>
                        </div>

                        <!-- Filter by Price -->
                        <div class="mb-5">
                            <div class="bg-brown p-2 text-white mb-3 small fw-bold rounded-1 px-3">Filter by Price</div>
                            
                            <div class="position-relative mb-4" style="height: 20px;">
                                <!-- Custom Visual Track -->
                                <div class="position-absolute top-50 start-0 translate-middle-y w-100 bg-secondary-subtle rounded-pill" style="height: 4px; z-index: 0;"></div>
                                <div class="position-absolute top-50 translate-middle-y bg-brown rounded-pill" style="height: 4px; z-index: 0;"
                                     :style="{ 
                                        left: ((filters.min_price - globalMinPrice) / (globalMaxPrice - globalMinPrice)) * 100 + '%',
                                        right: (100 - ((filters.max_price - globalMinPrice) / (globalMaxPrice - globalMinPrice)) * 100) + '%'
                                     }"></div>

                                <input type="range" class="form-range position-absolute w-100 h-100 top-0 start-0 m-0 p-0 dual-range-slider" 
                                       style="z-index: 1;"
                                       :min="globalMinPrice" :max="globalMaxPrice" id="minPriceRange" v-model.number="filters.min_price" @input="validateMinPrice">
                                <input type="range" class="form-range position-absolute w-100 h-100 top-0 start-0 m-0 p-0 dual-range-slider" 
                                       style="z-index: 2;"
                                       :min="globalMinPrice" :max="globalMaxPrice" id="maxPriceRange" v-model.number="filters.max_price" @input="validateMaxPrice">
                            </div>

                            <div class="d-flex justify-content-between small fw-bold mt-2">
                                <span>EGP {{ globalMinPrice }}</span>
                                <span>EGP {{ globalMaxPrice }}</span>
                            </div>
                            <div class="mt-3">
                                <span class="small text-muted">Price: EGP {{ filters.min_price }} - EGP {{ filters.max_price }}</span>
                                <button class="btn btn-brown btn-sm float-end py-1 px-3 rounded-pill" @click="applyFilters">Filter</button>
                            </div>
                        </div>

                        <!-- Filter by Category -->
                        <div class="mb-5">
                            <div class="bg-brown p-2 text-white mb-3 small fw-bold rounded-1 px-3">Filter by Categories
                            </div>
                            <div class="d-flex flex-column gap-2 small">
                                <div class="form-check" v-for="category in categories" :key="category.id">
                                    <template v-if="category">
                                        <input class="form-check-input border-secondary form-check-input-brown" type="checkbox" :value="category.id"
                                            :id="'cat' + category.id" v-model="filters.category_ids" @change="fetchProducts(1)">
                                        <label class="form-check-label text-muted" :for="'cat' + category.id">{{ category.text || category.name }}</label>
                                    </template>
                                </div>
                            </div>
                        </div>                        
                    </div>

                    <!-- Product Grid -->
                    <div class="col-lg-9">
                        <!-- Top Bar -->
                        <div class="d-flex justify-content-between align-items-center mb-4">
                            <span class="small text-muted" v-if="pagination && pagination.total">Showing {{ pagination.from }}-{{ pagination.to }} of {{ pagination.total }} results</span>
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle rounded-pill px-3 bg-white"
                                    type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Sort by latest
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" href="#">Latest</a></li>
                                    <li><a class="dropdown-item" href="#">Price: Low to High</a></li>
                                    <li><a class="dropdown-item" href="#">Price: High to Low</a></li>
                                </ul>
                            </div>
                        </div>

                        <!-- Loading State -->
                        <div v-if="loading" class="text-center py-5">
                            <div class="spinner-border text-brown" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>

                        <!-- Products -->
                        <div class="row g-4" v-else>
                            <div class="col-md-4" v-for="product in products" :key="product.id">
                                <product-card v-if="product" class="h-100" :product="product" @add-to-cart="addToCart"></product-card>
                            </div>
                        </div>

                        <!-- Pagination -->
                        <div class="d-flex justify-content-center mt-5" v-if="pagination.last_page > 1">
                            <nav aria-label="Page navigation">
                                <ul class="pagination gap-2 border-0">
                                    <li class="page-item" :class="{ disabled: page === 1 }">
                                        <a class="page-link rounded-circle border-0 text-dark bg-transparent" href="#" @click.prevent="fetchProducts(page - 1)">&lt;&lt;</a>
                                    </li>
                                    <li class="page-item" v-for="p in pagination.last_page" :key="p">
                                        <a class="page-link rounded-circle border-0" 
                                           :class="p === page ? 'bg-brown text-white' : 'text-dark bg-transparent'"
                                           href="#" @click.prevent="fetchProducts(p)">{{ p }}</a>
                                    </li>
                                    <li class="page-item" :class="{ disabled: page === pagination.last_page }">
                                        <a class="page-link rounded-circle border-0 text-dark bg-transparent" href="#" @click.prevent="fetchProducts(page + 1)">>></a>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                    </div>
                </div>
            </div>
        </section>

        <!-- Footer -->
        <footer-section :logo="logo"></footer-section>
    </div>
</template>

<script>
import Navbar from './Navbar.vue';
import ProductCard from './ProductCard.vue';

export default {
    components: { Navbar, ProductCard },
    props: {
        logo: {
            type: String,
            default: null
        },
        authUser: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            products: [],
            categories: [], // Available categories
            loading: true,
            pagination: {},
            page: 1,
            filters: {
                min_price: 0,
                max_price: 1000,
                category_ids: [],
                name: ''
            },
            priceRange: 1000, // UI bind for max price slider
            globalMinPrice: 0,
            globalMaxPrice: 1000
        }
    },
    mounted() {
        // Read URL params
        const urlParams = new URLSearchParams(window.location.search);
        const name = urlParams.get('name');
        if (name) {
            this.filters.name = name;
        }

        this.fetchCategories();
        this.fetchPriceRange();
        this.fetchProducts();
    },
    methods: {
        fetchCategories() {
            axios.get('/api/frontend/categories')
                .then(response => {
                    const data = response.data.data;
                    this.categories = Array.isArray(data) ? data.filter(c => c) : [];
                })
                .catch(error => {
                    console.error('Error fetching categories:', error);
                });
        },
        fetchProducts(page = 1) {
            this.loading = true;
            this.page = page;
            
            const params = {
                page: page,
                category_id: this.filters.category_ids.length ? this.filters.category_ids : null,
                min_price: this.filters.min_price,
                max_price: this.filters.max_price,
                name: this.filters.name || null
            };

            // Remove null params
            Object.keys(params).forEach(key => params[key] === null && delete params[key]);

            // Handling array params for axios if needed, but standard should work
            
            axios.get(`/api/frontend/products`, { params })
                .then(response => {
                    const result = response.data.data;
                    if (result && result.data) {
                        this.products = (result.data || []).filter(p => p);
                        this.pagination = result.meta || {};
                    } else {
                         this.products = [];
                    }
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        addToCart(product) {
            if (!this.authUser) {
                // Redirect to login or show modal
                window.location.href = '/customer/login';
                return;
            }
            
            axios.post('/api/frontend/cart/add', {
                product_id: product.id,
                quantity: 1,
                price: product.price // Logic usually handles this backend side but Builder might need it
            })
            .then(response => {
                // Emit event to update navbar cart count
                // Assuming response returns cart object with items
                // Or we can just increment count if we don't get full count back, but better to use response
                const cart = response.data.data;
                let count = 0;
                if(cart && cart.cart_items) {
                     count = cart.cart_items.length;
                }
                window.Bus.$emit('cart-updated', count);
                
                this.$swal.fire({
                    icon: 'success',
                    title: 'Added to Cart!',
                    text: 'Product has been added to your cart.',
                    timer: 2000,
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end'
                });
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                if (error.response && error.response.status === 401) {
                     window.location.href = '/customer/login';
                }
            });
        },
        applyFilters() {
            this.fetchProducts(1);
        },
        resetFilters() {
            this.filters.min_price = this.globalMinPrice;
            this.filters.max_price = this.globalMaxPrice;
            this.filters.category_ids = [];
            this.fetchProducts(1);
        },
        validateMinPrice() {
            if (this.filters.min_price > this.filters.max_price) {
                this.filters.min_price = this.filters.max_price;
            }
        },
        validateMaxPrice() {
            if (this.filters.max_price < this.filters.min_price) {
                this.filters.max_price = this.filters.min_price;
            }
        },
        fetchPriceRange() {
            axios.get('/api/frontend/products/price-range')
                .then(response => {
                    const { min, max } = response.data.data;
                    this.globalMinPrice = Math.floor(min);
                    this.globalMaxPrice = Math.ceil(max);
                    
                    // Initialize filters with fetched range if needed, or keep 0-max
                    // Usually you want to start with full range selected
                    this.filters.min_price = this.globalMinPrice;
                    this.filters.max_price = this.globalMaxPrice;
                })
                .catch(error => {
                    console.error('Error fetching price range:', error);
                });
        }
    }
}
</script>

<style scoped>
/* Dual Range Slider Styles */
.dual-range-slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: none;
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
    padding: 0;
    display: block;
    border: none;
    outline: none;
}

/* Track styling to ensure consistent "middle" baseline */
.dual-range-slider::-webkit-slider-runnable-track {
    width: 100%;
    height: 1px; /* Minimal height to anchor thumb */
    cursor: pointer;
    background: transparent;
    border: none;
}

.dual-range-slider::-webkit-slider-thumb {
    pointer-events: auto;
    width: 16px;
    height: 16px;
    background: #A0522D;
    cursor: pointer;
    border-radius: 50%;
    -webkit-appearance: none;
    appearance: none;
    margin-top: -8px; /* Center relative to 1px track: -0.5px (track half) - 8px (thumb half) approx -8px */
    box-shadow: 0 0 2px rgba(0,0,0,0.5);
    position: relative;
    z-index: 10;
}

.dual-range-slider::-moz-range-track {
    width: 100%;
    height: 1px;
    cursor: pointer;
    background: transparent;
    border: none;
}

.dual-range-slider::-moz-range-thumb {
    pointer-events: auto;
    width: 16px;
    height: 16px;
    background: #A0522D;
    cursor: pointer;
    border-radius: 50%;
    border: none;
    box-shadow: 0 0 2px rgba(0,0,0,0.5);
    transform: translateY(-50%); /* Firefox often centers tracks differently, transform is safer */
    margin-top: 0;
}

/* Custom Checkbox Color */
.form-check-input-brown:checked {
    background-color: #A0522D;
    border-color: #A0522D;
}
</style>
